export const HOME_ROUTE = "/"

export const STRATEGY_ROUTE = "strategie"
export const STRATEGY_ABSOLUTE_ROUTE = HOME_ROUTE + "strategie"

export const COACH_ENJOY_STRATEGY_ROUTE = "coach-enjoy-strategie"
export const OKR_ROUTE = HOME_ROUTE + "okr"

export const ENJOY_NEWS_ROUTE = HOME_ROUTE +"enjoynews"

export const PROJECTS_ROUTE = 'projets'
export const PROJECTS_ABSOLUTE_ROUTE = HOME_ROUTE + "projets"
export const ACTIONS_ROUTE = HOME_ROUTE + "actions"
export const MY_ACCOUNT = 'mon-compte'
export const MY_ACCOUNT_ROUTE = MY_ACCOUNT
export const GUIDED_UPDATE_PROJECT_ROUTE = HOME_ROUTE + "maj-projet"
export const GUIDED_UPDATE_PROJECT_WITH_ID_ROUTE = GUIDED_UPDATE_PROJECT_ROUTE + '/:id'

export const SETTINGS_ROUTE = HOME_ROUTE + "parametres"
export const EYBLEARNING_ROUTE = HOME_ROUTE + "EYBLearning"



// DASHBOARDS ROUTES
export const DASHBOARD_ROUTE = "dashboard"
export const DASHBOARD_ABSOLUTE_ROUTE = HOME_ROUTE + "dashboard"

export const ENJOY_BOARD_ROUTE = "enjoyboard"

export const MEMBERS_BOARD_ROUTES = "tableau-membres"

export const ROADMAP_ROUTES = "roadmap"

export const CALL_AGAIN_BOARD_ROUTES = "tableau-relances"

export const PITCH_STRATEGY_ROUTE = "pitch-strategie"

////
export const TAGS_ROUTE = SETTINGS_ROUTE + "/tags"
export const ARCHIVE_ROUTE = SETTINGS_ROUTE + "/archives"
export const PERSONALISATION_ROUTE = SETTINGS_ROUTE + "/personnaliser-strategy"
export const USERS_ROUTE_NAME = "utilisateurs"
export const USERS_ROUTE = SETTINGS_ROUTE + "/" + USERS_ROUTE_NAME

export const SECURITY = "securite"
export const SECURITY_ROUTE = SETTINGS_ROUTE + "/" + SECURITY

export const PROFILE_NAME_ROUTE = 'profile'

export const PASSWORD = 'changer-mot-de-passe'
export const DELETE_ACCOUNT = 'supprimer-profil'

